<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <md-field :class="messageClass">
      <label>{{ saveData.label | token_replace(nid)}}</label>
      <md-input
        v-model="saveData.value"
        :maxlength="saveData.counter && saveData.counter != '' && parseInt(saveData.counter) ? parseInt(saveData.counter) : null"
        :required="saveData.required === true ? 'required' : null"
      ></md-input>
      <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Input'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <label>{{ saveData.label | token_replace(nid)}}</label>
        <md-input
          v-model="tempData.value"
          :maxlength="saveData.counter && saveData.counter != '' && parseInt(saveData.counter) ? parseInt(saveData.counter) : null"
        ></md-input>
        <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      </md-field>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Value</label>
          <md-input v-model="tempData.value"></md-input>
        </md-field>
        <md-field>
          <label>Counter</label>
          <md-input v-model="tempData.counter"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbInput",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true && this.saveData.value == "");
      return val;
    }
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        help_text: this.element.data.help_text || "",
        counter: this.element.data.counter || '',
        required: this.element.data.required || false
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        help_text: this.element.data.help_text || "",
        counter: this.element.data.counter || '',
        required: this.element.data.required || false
      }
    };
  },
  watch: {
    "saveData.value": function value() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>
